import axios from "axios";
import api from "../../../../../services/axios";

export const GetCallLogReportExcel = async (payload) => {
  try {
    const res = await api.post(
      "/Employee/RecruitmentReport/reports/calllog",
      payload,
      {
        responseType: "blob",
        headers: {
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      }
    );

    return res;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const GetCallLogReport = async (payload) => {
  try {
    const res = await api.post(
      "/Employee/RecruitmentReport/reports/calllog",
      payload
    );

    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};